import React, { Component } from 'react';
import { Container, Row, Col, Form, Image, Button } from 'react-bootstrap';
import ReactNotification from 'react-notifications-component';

import NavbarComponent from '../Navbar/index';
import RenovateTokenAlert from '../../RenovateToken';

import InvoicePayment from './invoicePayment.js'
import InvoiceHistory from './invoiceHistory.js'

export default class SettingIndex extends Component {
  constructor(props){
    super(props)
    this.state = {
      tab:'invoice'
    }
  }

  renderContent(){
    return(
      <div>
        <InvoicePayment {...this.props}/>
        <InvoiceHistory {...this.props}/>
      </div>        
    )
    // switch (this.state.tab) {
    //   case 'invoice':
        
    //     break;
    //   case 'history':
    //     return(
    //       <InvoiceHistory {...this.props}/>
    //     )
    //     break;
    // }
  }
  render(){
    return(

        <div>
          <NavbarComponent data={this.props} selected="invoices" logged={true} />
          <RenovateTokenAlert data={this.props} />
          <div className="contenedor-wallets-generals">
            <Container fluid>

              <Row>
                <Col lg={{span:10, offset:1}}>
                  <div className=''>
                    {/* <div className='profile_list_menu'>
                      <button onClick={()=>this.setState({tab:'invoice'})} className={(this.state.tab == 'invoice')&& 'active'}>Invoice Payment</button>
                      <button onClick={()=>this.setState({tab:'history'})} className={(this.state.tab == 'history')&& 'active'}>Invoice History</button>
                    </div> */}
                    {this.renderContent()}
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
    )
  }
}
